import React from 'react';
import type { SpecifiedEntityFormValues } from '../SpecifiedEntityExclusionModal';
import { SpecifiedEntityExclusionModal } from '../SpecifiedEntityExclusionModal';
import {
  formatExclusionsForState,
  getDefaultExclusionValues,
} from '../../amendatory-coverages/line-items/SpecifiedEntityExclusion';
import type {
  EventExclusions,
  RaterXCoverage,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';

const RaterXSpecifiedEntityExclusionsModal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: SpecifiedEntityFormValues) => {
    const _exclusions = formatExclusionsForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as EventExclusions[] },
        },
      },
    });
  };
  return (
    <SpecifiedEntityExclusionModal
      close={close}
      data={{
        onSubmit,
        showDescription: true,
        exclusions: getDefaultExclusionValues(
          data.coverageState.value?.props?.exclusions
            ?.values as EventExclusions[]
        ),
      }}
    />
  );
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
  };
  close: () => void;
};

export const RaterXSpecifiedEntityExclusionsModalConfig = {
  RaterXSpecifiedEntityExclusionsModal: {
    component: RaterXSpecifiedEntityExclusionsModal,
    config: {
      title: 'Specified Entity Exclusion Endorsement',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
